import React, { FC, ReactElement } from 'react'
import BitconIcon from '@/icons/bitcoin-filled'
import classNames from 'classnames'
import useSatoshiPriceUSD from '@/utils/hooks/useSatoshiPriceUSD'
import useUSDToggle from '@/utils/hooks/useUSDToggle'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const InscriptionSalePrice: FC<{
	price: number
}> = (props): ReactElement => {
	const [showUSD, setShowUSD] = useUSDToggle()
	const displayPrice = React.useMemo(() => (props.price / 1e8).toFixed(8), [props.price])

	const [priceUSD] = useSatoshiPriceUSD(props.price)

	return (
		<div
			className="flex items-center justify-between"
			onClick={() => setShowUSD(!showUSD)}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(() => setShowUSD(!showUSD))}
		>
			{showUSD ? (
				<div className="flex items-center">
					<p className={classNames('text-sm', 'semibold')}>${priceUSD}</p>
				</div>
			) : (
				<div className="flex gap-1 items-center">
					<BitconIcon className="size-4" />
					<p className="text-xs font-semibold">{displayPrice}</p>
				</div>
			)}
			<div className="h-7 bg-[#F04438] opacity-50 text-foreground text-sm font-semibold flex items-center justify-center px-4 rounded-full">
				Sold
			</div>
		</div>
	)
}

export default InscriptionSalePrice
